<template>
  <section>
    <div class="h-70 row align-items-center no-gutters">
      <div class='container'>
        <div class='col'>

          <!-- Sobre nós -->
          <div class='row'>
            <div class='col'>
              <div class='title text-center'> {{$t('about-us.title')}}</div>
            </div>
          </div>
          <div class='row'>
            <div class='col justify-content-center'>
              <div class='content text-center'>
                {{$t('about-us.description')}}
              </div>
            </div>
          </div>

          <!-- Nossos serviços -->
          <div class='row' style='margin-top: 95px; margin-bottom: 60px;'>
            <div class='col'>
              <div class='subtitle' v-html="$t('about-us.service.title')"></div>
            </div>
          </div>
          <div class='row'>
            <div class="col-sm-12 col-md-4 mx-auto text-left" v-for="item in $t('about-us.service.row1')" :key="item">
              <div class='card'>
                <div>
                <div class='card-body justify-content-center card-content' v-html="item">
                </div>
                  <span style="padding-left: 20px;">
                    Descrição do seu serviço
                  </span>
                </div>
                  
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AboutUs'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  section {
    color: rgba(63, 63, 63, 0.9);
    padding: 120px 0px;
  }

  .title {
    font-family: Lora, serif;
    font-style: normal;
    font-weight: bold;
    font-size: 42px;
    line-height: 60px;
    
  }

  .content {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: normal;
    font-size: 25px;
    line-height: 40px;


    margin-top: 55px;
  }

  .subtitle {
    font-family: Lora;
    font-style: normal;
    font-weight: bold;
    font-size: 38px;
    line-height: 52px;
    text-align: center;

  }

  .card {
    height: 103px;

    background: white;
    color: black;
    box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
  }

  .card-body {
    padding: 20px 0 0 20px;
  }
  .card-content {
    font-style: normal;
    font-weight: 500;
    font-size: 20px;

    text-align: left;

  }

  .mx-auto {
    padding: 10px;
  }

  @media (max-width: 575.98px) {
    .title {
      font-size: 29px;
      line-height: 30px;
    }

    section {
      color: #FFFFFF;
      padding: 80px 0px;
    }

    .content {
      font-size: 19px;
      line-height: 30px;
      text-align: left;
    }

    .subtitle {
      font-size: 29px;
      line-height: 30px;
    }

    .card-content {
      font-size: 18px;
    }
  }
</style>
